import { Link } from "wouter";
import vexisLogo from "@assets/vexis-logo-2026.jpg";

export function TrustFooter() {
  return (
    <footer className="text-white py-16" style={{ backgroundColor: "#0F1F3D", borderTop: "1px solid rgba(99,102,241,0.15)" }}>
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-8 mb-12">
          <div>
            <div className="mb-4">
              <img src={vexisLogo} alt="VEXIS Talent Agency" className="h-14 w-auto" data-testid="logo-footer" />
            </div>
            <p className="text-slate-400 text-sm max-w-xs">
              Vexis — AI-powered video assessment for recruitment agencies. Human review on every candidate. JobAdder integrated.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-white">Platform</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link href="/how-it-works" className="hover:text-white transition-colors">How It Works</Link></li>
              <li><Link href="/features" className="hover:text-white transition-colors">Features</Link></li>
              <li><Link href="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
              <li><Link href="/partners" className="hover:text-white transition-colors">JobAdder Integration</Link></li>
              <li><Link href="/security" className="hover:text-white transition-colors">Security</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-white">Company</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link href="/about" className="hover:text-white transition-colors">About Vexis</Link></li>
              <li><Link href="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link href="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="hover:text-white transition-colors">Terms</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-white">Trust & Process</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link href="/methodology" className="hover:text-white transition-colors">Methodology</Link></li>
              <li><Link href="/process-controls" className="hover:text-white transition-colors">Process Controls</Link></li>
              <li><Link href="/deliverables" className="hover:text-white transition-colors">Deliverables</Link></li>
              <li><Link href="/compliance-data-handling" className="hover:text-white transition-colors">Compliance</Link></li>
              <li><Link href="/document-library" className="hover:text-white transition-colors">Documents</Link></li>
              <li><Link href="/change-log" className="hover:text-white transition-colors">Change Log</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-white">Legal & Security</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link href="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
              <li><Link href="/security" className="hover:text-white transition-colors">Security</Link></li>
              <li><Link href="/contact" className="hover:text-white transition-colors">Hiring Operations Enquiries</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <p className="text-sm text-slate-500">
                © 2026 Vexis Talent Agency. A trading name of LHA Holdings Ltd.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-4 md:gap-6 text-sm text-slate-500">
              <a href="tel:+64212458827" className="hover:text-slate-300 transition-colors">+64 212 458 827</a>
              <span>Auckland</span>
              <span>Sydney</span>
              <span>Melbourne</span>
              <span>Brisbane</span>
              <span>London</span>
              <span>Florida</span>
              <span>Vancouver</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
